<template>
    <div id="template" class="field">
        <label>
            {{ $t('ui.toolbox.core_waybills_label_svg.labels.template') }}
        </label>

        <div class="ui right basic button dropdown item" tabindex="0"
            v-dropdown>
            <span>
                 {{ current_template }}
            </span>
            <i class="dropdown icon"></i>
            <div class="menu left transition hidden" tabindex="-1">
                <div class="item"
                    style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 200px;
                        height: 200px;">
                    <div @mouseout="mouseout()">
                        <div class="hover_row" v-for="row_index in [1,2,3,4,5,6]">
                            <TemplateBox
                                v-for="item_index in [1,2,3,4,5,6]"
                                :current_item_index="current_item_index"
                                :current_row_index="current_row_index"
                                :item_index="item_index"
                                :row_index="row_index"
                            >
                            </TemplateBox>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import TemplateBox from './template_box.vue'

export default {
    name: "ToolCoreWaybillsLabelSvgNewLabelPaperSize",
    components: {
        TemplateBox
    },
    props: {
        channel: String,
        template: {
            type: String,
            default: "A4"
        },
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
            is_can_work: true,
            current_template: "",
            current_item_index: 1,
            current_row_index: 1,
            finish_item_index: 1,
            finish_row_index: 1,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
        template: {
            immediate: true,
            handler(value) {
                this.current_template = value
            }
        },
        current_template(value) {
            if (this.channel) {
                this.$bus.$emit(this.channel, value)
            }
        }
    },
    methods: {
        mouseout() {
            this.current_item_index = _.clone(this.finish_item_index)
            this.current_row_index = _.clone(this.finish_row_index)
        },
        set_current(row_index, item_index) {
            if (this.is_can_work) {
                this.current_row_index = row_index
                this.current_item_index = item_index
            }
        },
        set_template(row_index, item_index) {
            this.is_can_work = false
            this.finish_item_index = _.clone(item_index)
            this.finish_row_index = _.clone(row_index)
            this.current_template = String(row_index)+"x"+String(item_index)
            setTimeout(() => {
                this.is_can_work = true
            }, 1000)
        },
    },

}
</script>

<style scoped lang="scss">
    .hover_row {
        display: block;
        clear: both;
    }
</style>
